import React from "react";

import classes from "./DotLoader.module.css";

interface DotLoaderProps {
  color?: string;
  size?: number;
  fadeOpacity?: number; // Add this prop
  className?: string;
  style?: React.CSSProperties;
}

const DotLoader: React.FC<DotLoaderProps> = ({
  color = "#3E73A4",
  size = 10,
  fadeOpacity = 20,
  className = "",
  style = {},
}) => {
  const baseStyles = {
    "--dot-color": color,
    "--dot-fade-color": color + fadeOpacity,
    "--dot-size": `${size}px`,
    ...style,
  } as React.CSSProperties;

  return (
    <div
      className={`${classes.dotFlashing} ${className}`}
      style={baseStyles}
    ></div>
  );
};

export default DotLoader;
